



































































































































import BaseComponent from '@/core/base.component';
import { Component, Vue } from 'vue-property-decorator';
import { CompanyDistrictDto, CompanyDistrictPromotionDto } from '@/dto';
import CompanyDistrictPromotionService from '@/services/company-district-promotion.service';
import CompanyDistrictService from '@/services/company-district.service';
import CodeManagementService from '@/services/code-management.service';
import { CONST_YN, YN, Pagination } from '@/common';
import toast from '../../../../resources/assets/js/services/toast.js';
import { VueEditor } from 'vue2-editor';
import { EditorConfig } from '../../../config';

@Component({
  name: 'CompanyDistrictPromotionDetail',
  components: {
    VueEditor,
  },
})
export default class CompanyDistrictPromotionDetail extends BaseComponent {
  private promotionDto = new CompanyDistrictPromotionDto();
  private companyDistrictDto = new CompanyDistrictDto();
  private promitionTypeSelect = [];
  private companyDistrictSelect: CompanyDistrictDto[] = [];
  private showYn: YN[] = [...CONST_YN];
  private companyDistrictIds: number[] = [];
  private companyDistrictSelectedIds: number[] = [];
  private editorToolbar = EditorConfig;
  private startedDate = new Date();
  private endedDate = new Date();

  findOne(id) {
    CompanyDistrictPromotionService.findOne(id).subscribe(res => {
      if (res) {
        this.promotionDto = res.data;
        if (this.promotionDto.companyDistricts.length > 0) {
          this.companyDistrictSelectedIds = this.promotionDto.companyDistricts.map(
            v => v.no,
          );
        }
        this.startedDate = this.promotionDto.started;
        this.endedDate = this.promotionDto.ended;
      }
    });
  }

  getCompanyDistrict() {
    const companyDistrictDto = new CompanyDistrictDto();
    CompanyDistrictService.findForSelectOption(companyDistrictDto).subscribe(
      res => {
        if (res) {
          this.companyDistrictSelect = res.data;
        }
      },
    );
  }

  addDistrict(districtNo) {
    if (this.companyDistrictIds.includes(parseInt(districtNo))) {
      const index = this.companyDistrictIds.indexOf(parseInt(districtNo));
      if (index > -1) {
        this.companyDistrictIds.splice(index, 1);
      }
    } else {
      this.companyDistrictIds.unshift(parseInt(districtNo));
    }
  }

  updateOne() {
    if (this.companyDistrictSelectedIds) {
      this.promotionDto.companyDistrictIds = this.companyDistrictSelectedIds;
    }
    if (this.startedDate) {
      this.promotionDto.started = this.startedDate;
    }
    if (this.endedDate) {
      this.promotionDto.ended = this.endedDate;
    }
    CompanyDistrictPromotionService.update(
      this.$route.params.id,
      this.promotionDto,
    ).subscribe(res => {
      if (res) {
        toast.success('수정완료');
        this.findOne(this.$route.params.id);
      }
    });
  }

  deleteOne() {
    CompanyDistrictPromotionService.deleteOne(this.$route.params.id).subscribe(
      res => {
        if (res) {
          toast.success('삭제완료');
          this.$router.push('/company-district-promotion');
        }
      },
    );
  }

  created() {
    this.findOne(this.$route.params.id);
    this.getCompanyDistrict();
    this.getCommonCodes('promitionTypeSelect', 'B2B_EVENT_TYPE');
  }
}
